var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"camera",on:{"click":_vm.toggleMuteVideo}},[(!_vm.isVideoMuted)?_c('span',{staticClass:"icon camera-on"},[_c('svg-icon',{attrs:{"icon-name":"camera"}})],1):_vm._e(),(_vm.isVideoMuted)?_c('span',{staticClass:"icon camera-off"},[_c('svg-icon',{attrs:{"icon-name":"video-muted"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }